<template>
  <v-dialog v-model="dialog" width="700">
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        <v-avatar size="32" class="mr-2">
          <v-img :src="avatar_img" />
        </v-avatar>
        <div>
          {{ nome[0] }}
          <span v-if="nome[1]" class="grey--text text-caption"
            >— {{ nome[1] }}</span
          >
        </div>
        <v-spacer />
        <span class="text-body-2 grey--text">Lotto {{ lotto_codice }}</span>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4" style="max-height: 70vh; overflow-y: auto">
        <div class="d-flex align-start flex-wrap mb-4" style="gap: 24px">
          <div class="d-flex align-center">
            <v-avatar v-if="fornitore_logo" size="36" class="mr-2">
              <v-img :src="fornitore_logo" />
            </v-avatar>
            <div>
              <div class="text-body-2 font-weight-medium">
                {{ fornitore ? fornitore.nome : "Fornitore sconosciuto" }}
              </div>
              <div
                v-if="fornitore && (fornitore.indirizzo || fornitore.citta)"
                class="text-caption grey--text"
              >
                <template v-if="fornitore.indirizzo"
                  >{{ fornitore.indirizzo
                  }}<template v-if="fornitore.citta">, </template></template
                >{{ fornitore.citta }}
              </div>
              <div
                v-if="fornitore && (fornitore.telefono || fornitore.email)"
                class="text-caption grey--text"
              >
                <template v-if="fornitore.telefono">{{
                  fornitore.telefono
                }}</template>
                <template v-if="fornitore.telefono && fornitore.email">
                  · </template
                ><template v-if="fornitore.email">{{
                  fornitore.email
                }}</template>
              </div>
            </div>
          </div>
          <div>
            <div class="text-body-2">
              N. Documento:
              <b>{{ lotto && lotto.n_documento ? lotto.n_documento : "—" }}</b>
            </div>
            <div class="text-body-2 mt-1">
              Trapianto: <b>{{ data_trapianto }}</b>
            </div>
          </div>
        </div>

        <v-divider class="my-4" />

        <div class="text-overline grey--text text--darken-1">
          Cronologia Posizioni
        </div>
        <template v-if="storico_posizioni.length">
          <div
            v-for="(mov, i) in storico_posizioni"
            :key="i"
            class="d-flex align-center flex-wrap py-1"
            style="gap: 8px"
          >
            <span class="text-caption grey--text" style="min-width: 110px">{{
              formatData(mov.ts)
            }}</span>
            <v-chip
              v-for="id_serra in mov.serre"
              :key="id_serra"
              x-small
              outlined
              color="blue darken-1"
            >
              <v-icon x-small left>mdi-map-marker-radius-outline</v-icon>
              {{ nome_serra(id_serra) }}
            </v-chip>
          </div>
        </template>
        <div v-else class="text-caption grey--text font-italic mb-4">
          Nessuno spostamento registrato (lo storico è disponibile solo da
          quando è stata introdotta questa funzione).
        </div>

        <v-divider class="my-4" />

        <div class="text-overline grey--text text--darken-1">
          Trattamenti Ricevuti
        </div>
        <v-progress-linear v-if="loading_trattamenti" indeterminate class="mb-2" />
        <template v-else>
          <div
            v-if="!trattamenti.length"
            class="text-caption grey--text font-italic mb-4"
          >
            Nessun trattamento registrato.
          </div>
          <div v-for="evento in trattamenti" :key="evento.id" class="mb-2">
            <span class="text-caption grey--text mr-2">{{
              formatData(evento.ts)
            }}</span>
            <span
              v-for="fito in evento.fitofarmaci"
              :key="fito.id"
              class="mr-2 text-body-2"
            >
              <b>{{ nome_fito(fito.id_fitofarmaco) }}</b>
              ({{ fito.qta_impiegata }} Kg/Lt.)
            </span>
          </div>
        </template>

        <v-divider class="my-4" />

        <div class="text-overline grey--text text--darken-1">
          Clienti che hanno acquistato
        </div>
        <v-progress-linear v-if="loading_clienti" indeterminate class="mb-2" />
        <template v-else>
          <div
            v-if="!movimenti_clienti.length"
            class="text-caption grey--text font-italic"
          >
            Nessuna vendita registrata per questo lotto/prodotto.
          </div>
          <v-list v-else dense class="py-0">
            <v-list-item v-for="(mov, i) in movimenti_clienti" :key="i">
              <v-list-item-content>
                <v-list-item-title class="text-body-2">{{
                  nome_cliente(mov.cliente)
                }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption"
                  >{{ formatData(mov.ts) }} · {{ mov.qta }} pz</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn outlined color="purple" @click="stampaPdf()">
          <v-icon class="mr-2">mdi-printer</v-icon>Stampa
        </v-btn>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "StoriaLottoDialog",
  data() {
    return {
      dialog: false,
      id_lotto: null,
      coltura: null,
      trattamenti: [],
      loading_trattamenti: false,
      movimenti_clienti: [],
      loading_clienti: false,
    };
  },
  computed: {
    lotto() {
      let lotto = this.$store.getters.get_lotto_by_id(this.id_lotto);
      if (lotto) return lotto;
      if (this.id_lotto) this.$store.dispatch("get_lotto_by_id", this.id_lotto);
      return null;
    },
    lotto_codice() {
      return this.lotto ? this.lotto.codice : this.id_lotto;
    },
    fornitore() {
      if (!this.lotto) return null;
      return this.$store.getters.get_fornitore_by_id(this.lotto.id_fornitore);
    },
    fornitore_logo() {
      if (!this.fornitore) return null;
      return (
        process.env.VUE_APP_API_ROOT +
        "/fornitore/" +
        this.fornitore.id +
        "/avatar?t=" +
        this.fornitore.logo_md5
      );
    },
    prodotto() {
      return this.coltura
        ? this.$store.getters.get_prodotto_raw_by_id(this.coltura.id_prodotto)
        : null;
    },
    avatar_img() {
      return this.coltura
        ? process.env.VUE_APP_API_ROOT + "/avatar_img/" + this.coltura.id_prodotto
        : "";
    },
    nome() {
      return this.prodotto ? this.prodotto.nome.split(" in ") : ["Prodotto"];
    },
    data_trapianto() {
      return this.coltura && this.coltura.ts_trapianto
        ? moment.unix(this.coltura.ts_trapianto).format("DD MMMM YYYY")
        : "—";
    },
    // Più recente per primo: storico_posizioni è append-only lato backend.
    storico_posizioni() {
      if (!this.coltura || !this.coltura.storico_posizioni) return [];
      return [...this.coltura.storico_posizioni].sort((a, b) => b.ts - a.ts);
    },
  },
  methods: {
    open(id_lotto, coltura) {
      this.id_lotto = id_lotto;
      this.coltura = coltura;
      this.dialog = true;
      this.caricaTrattamenti();
      this.caricaClienti();
    },
    caricaTrattamenti() {
      // I fitofarmaci si caricano solo visitando il QDC (fetch_fitofarmaci
      // non è nel bootstrap globale): qui il dialog può aprirsi da /lotti o
      // dalla mappa aziendale senza mai essere passati da lì, quindi
      // nome_fito() cadrebbe sempre sull'id senza questo fetch di riserva.
      if (!this.$store.getters.get_fitofarmaci.length) {
        this.$store.dispatch("fetch_fitofarmaci");
      }
      this.loading_trattamenti = true;
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/qdc/eventi/coltura/" +
        this.coltura.id_prodotto +
        "/lotto/" +
        this.id_lotto;
      let auth = this.$store.getters.get_credential;
      axios
        .get(url, { auth: auth })
        .then((res) => {
          this.trattamenti = res.data;
        })
        .finally(() => {
          this.loading_trattamenti = false;
        });
    },
    caricaClienti() {
      this.loading_clienti = true;
      // Riusa l'azione già esistente dietro "Ricerca Lotto" (ricerca
      // manuale/scanner) invece di duplicarne la logica: ts_inizio=0 per
      // avere la storia completa, non solo l'ultimo anno come in quel flusso.
      this.$store
        .dispatch("ricerca_movimento_lotto", {
          id_prodotto: this.coltura.id_prodotto,
          id_lotto: this.lotto_codice,
          ts_inizio: 0,
        })
        .then((res) => {
          this.movimenti_clienti = res.clienti || [];
        })
        .catch(() => {
          this.movimenti_clienti = [];
        })
        .finally(() => {
          this.loading_clienti = false;
        });
    },
    nome_serra(id) {
      let serra = this.$store.getters.getSerraById(id);
      return serra ? serra.nome : id;
    },
    nome_fito(id) {
      let fito = this.$store.getters.get_fitofarmaco_by_id(id);
      return fito ? fito.dettagli.prodotto : id;
    },
    nome_cliente(iva) {
      let cliente = this.$store.getters.get_cliente_by_iva(iva);
      return cliente ? cliente.nome : iva;
    },
    formatData(ts) {
      return ts ? moment.unix(ts).format("DD MMMM YYYY") : "—";
    },
    stampaPdf() {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/lotti/" +
        this.id_lotto +
        "/prodotto/" +
        this.coltura.id_prodotto +
        "/storia_pdf";
      let token = this.$store.getters.get_token;
      // Apertura in una nuova scheda via submit di form (come le altre
      // stampe): il token va nel body, non in un header Authorization, per
      // poter fare un semplice <form target="_blank"> senza passare da axios.
      let form = document.createElement("form");
      form.target = "_blank";
      form.method = "POST";
      form.action = url;
      form.style.display = "none";
      let input = document.createElement("input");
      input.type = "hidden";
      input.name = "token";
      input.value = token;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
  },
};
</script>
